import axios from "../../../../api/axios";

export const deleteEntityBranch = async (branchId: string): Promise<any> => {
  const response = await axios.delete<{ message: string }>(`/football-entity-branches/${branchId}`);
  return response.data;
};

export const updateEntityBranch = async (branchId: string, data: any): Promise<any> => {
  const response = await axios.patch(`/football-entity-branches/${branchId}`, data);
  return response.data;
};
